import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { translate, autoFocus, isNullOrEmpty, showMessageToast } from '../../../../utils/util';
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import LinePickingService from '../../../../services/LinePickingService';
import { Input, Card, Collapsible, Button, SelectItem } from '../../../../components/UI/ComponentsUI';
import SelectMapping from '../../../../components/UI/SelectMapping';
import { ENUMS } from '../../../../utils/constants';
import SelectRoute from '../../../../components/UI/SelectRoute';

const CreatePartOutside = (props) => {
    const [data, setData] = useState({});
    const [filter, setFilter] = useState({
        partNumber: ""
    });
    const [addVisible, setAddvisible] = useState(false);

    useEffect(() => {
        autoFocus("txtPartNumber");
        // eslint-disable-next-line
    }, []);

    const onChange = (event) => {
        onValueChange(event, data, setData);

        let dataMappingFilter = data.mappings || [];
        if (!isNullOrEmpty(data.route)) {
            dataMappingFilter = data.mappings.filter((f) => f.route.toString() === data.route);
            data.pdu = dataMappingFilter.length === 0 ? "" : dataMappingFilter[0].pdu
            document.getElementById("pdu").value = data.pdu
        }

        if (!isNullOrEmpty(data.street)) {
            dataMappingFilter = data.mappings.filter((f) => f.street.toString() === data.street)
            data.pdu = dataMappingFilter.length === 0 ? "" : dataMappingFilter[0].pdu
            document.getElementById("pdu").value = data.pdu
        }

        if (!isNullOrEmpty(data.station)) {
            dataMappingFilter = data.mappings.filter((f) => f.station.toString() === data.station)
            data.pdu = dataMappingFilter.length === 0 ? "" : dataMappingFilter[0].pdu
            document.getElementById("pdu").value = data.pdu
        }

        if (!isNullOrEmpty(data.line)) {
            dataMappingFilter = data.mappings.filter((f) => f.line.toString() === data.line)
            data.pdu = dataMappingFilter.length === 0 ? "" : dataMappingFilter[0].pdu
            document.getElementById("pdu").value = data.pdu
        }

        if (!isNullOrEmpty(data.gravitational)) {
            dataMappingFilter = data.mappings.filter((f) => f.gravitational.toString() === data.gravitational)
            data.pdu = dataMappingFilter.length === 0 ? "" : dataMappingFilter[0].pdu
            document.getElementById("pdu").value = data.pdu
        }

        if (!isNullOrEmpty(data.space)) {
            dataMappingFilter = data.mappings.filter((f) => f.space.toString() === data.space)
            data.pdu = dataMappingFilter.length === 0 ? "" : dataMappingFilter[0].pdu
            document.getElementById("pdu").value = data.pdu
        }

        if (!isNullOrEmpty(data.side)) {
            dataMappingFilter = data.mappings.filter((f) => f.side.toString() === data.side)
            data.pdu = dataMappingFilter.length === 0 ? "" : dataMappingFilter[0].pdu
            document.getElementById("pdu").value = data.pdu
        }

        setData({ ...data });

    };

    const onChangeFilter = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const handleOnKeyDown = (event) => {
        if (event.key === 'Enter') {
            onChangeFilter(event);
        }
    }

    const onAddPart = () => {
        if (validateInputsRequired("inputPartNumber")) {
            const visible = addVisible ? false : true;
            if (visible) {
                props.getPartNumbers(filter.partNumber, (data) => {
                    setAddvisible(addVisible ? false : true)
                    setData(data)

                })
            } else {
                setAddvisible(visible)
            }
        }
    }

    const insert = () => {
        var mapping = data.mappings.find(f => f.pdu === data.pdu)
        if (isNullOrEmpty(mapping)) {
            return showMessageToast({ html: 'PDU Invalido para mapatura', classes: 'red' });
        }

        data.mappingId = mapping.id;
        props.insertRequestOutSide(data, () => {
            setData({})
            setAddvisible(false);
            props.callback();
        })
    }

    return (
        <div>
            <Card>
                <div className='row' id="inputPartNumber">
                    <div className="input-field no-padding col s9">
                        <Input
                            required
                            label={translate('scanner-receipt.partnumber')}
                            id="partNumber"
                            name="partNumber"
                            type="text"
                            onChange={onChangeFilter}
                            onKeyDown={(e) => handleOnKeyDown(e)}
                            value={filter.partNumber}
                        />
                    </div>
                    <div className="input-field no-padding col s2">
                        <button
                            className="btn-floating btn-Small btn-principal waves-effect waves-light"
                            type="button"
                            onClick={() => {
                                onAddPart()
                            }}>
                            <i className="Small material-icons">add</i>
                        </button>
                    </div>
                </div>
            </Card>
            {
                addVisible && !isNullOrEmpty(filter.partNumber) &&
                <Collapsible
                    id="collapsible2"
                    header={"Chamada Mapatura"}
                    body={
                        <>
                            <div id="formfilter" className="row">
                                <div className="input-field no-padding col s11">
                                    <Input
                                        disabled
                                        id="partNumber"
                                        name='partNumber'
                                        type="text"
                                        maxLength="11"
                                        defaultValue={filter?.partNumber || ''}
                                    />
                                </div>
                                <div className="input-field no-padding col s6">
                                    <Input
                                        id="station"
                                        name='station'
                                        label={translate('mapping:station', 'line-picking')}
                                        type="number"
                                        maxLength="3"
                                        value={data?.station || ''}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s5">
                                    <SelectItem
                                        id="side"
                                        defaultValue={data?.side || ''}
                                        label={translate('mapping:side', 'line-picking')}
                                        placeHolder={translate('general:choose-one-option')}
                                        onChange={onChange}
                                        onChangeData={onChange}
                                        minLength={0}
                                        changeEvent="true"
                                        data={[{ id: "SX", text: "SX", },
                                        { id: "DX", text: "DX" }
                                        ]}
                                    />
                                </div>
                                <div className="input-field no-padding col s6">
                                    <SelectMapping
                                        required
                                        name='line'
                                        mappingType={ENUMS.eMappingRegistrationType.Line.value}
                                        defaultValue={data?.line || ''}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s5">
                                    <SelectRoute
                                        {...props}
                                        name='route'
                                        id='route'
                                        defaultValue={data?.route || ''}
                                        routeType={ENUMS.eRouteType.LinePicking.value}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s6 m3">
                                    <SelectMapping
                                        showCode={true}
                                        required
                                        name='gravitational'
                                        mappingType={ENUMS.eMappingRegistrationType.Gravitational.value}
                                        defaultValue={data?.gravitational || ''}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s5 m3">
                                    <Input
                                        id="space"
                                        name='space'
                                        label={translate('mapping:space', 'line-picking')}
                                        type="text"
                                        value={data?.space || ''}
                                        onChange={onChange}
                                        required
                                    />
                                </div>
                                <div className="input-field no-padding col s6 m2">
                                    <Input
                                        id="street"
                                        name='street'
                                        label={translate('mapping:street', 'line-picking')}
                                        type="text"
                                        maxLength="2"
                                        value={data?.street || ''}
                                        onChange={onChange}
                                        required
                                    />
                                </div>
                                <div className="input-field no-padding col s5 m3">
                                    <SelectItem
                                        id="pdu"
                                        defaultValue={data?.pdu || ''}
                                        label={translate('mapping:pdu', 'line-picking')}
                                        placeHolder={translate('general:choose-one-option')}
                                        onChange={(event) => {
                                            onValueChange(event, data, setData);
                                        }}
                                        onChangeData={(event) => {
                                            onValueChange(event, data, setData);
                                        }}
                                        minLength={0}
                                        changeEvent="true"
                                        data={data.mappings.map(f => { return { id: f.pdu, text: f.pdu } })}
                                    />
                                </div>
                            </div>
                            <div className="row" style={{ paddingTop: '5px' }}>
                                <Button full="true" text={translate('send', 'general')} onClick={insert} />
                            </div>
                        </>
                    }
                />
            }
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        partsOutside: state.linePickingReducer.partOutsides
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPartNumbers: (partNumber, callback) => {
            dispatch(LinePickingService.getPartnumbersOutSide(partNumber, callback));
        },
        insertRequestOutSide: (data, callback) => {
            dispatch(LinePickingService.insertRequestOutSide(data, callback));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CreatePartOutside));